/**
 * Keep cover URLs on a fresh cache key after the image-ingestion repair.
 *
 * The previous URLs can still hold a 404 at Cloudflare for 33 days. A shared
 * version lets every card, carousel and social preview reach the repaired
 * image immediately while preserving normal caching of successful images.
 */
export function imageApiUrl(kind: "article" | "cluster" | "event", id: string): string {
  return `/api/images/${kind}/${encodeURIComponent(id)}?v=2`;
}
